import { useRuntimeConfig } from '#imports'
import type { Hanko, RegisterOptions } from '@teamhanko/hanko-elements'

export const hankoElementsOptions = {
  storageKey: 'hanko',
  cookieSameSite: 'lax',
} satisfies RegisterOptions

const hankoClientOptions = {
  cookieName: 'hanko',
  localStorageKey: 'hanko',
  cookieSameSite: 'lax' as const,
}

let hankoClient: Hanko | undefined

export const setHankoClient = (client: Hanko) => {
  hankoClient = client
}

export const useHankoClient = async (): Promise<Hanko> => {
  if (hankoClient) return hankoClient

  const config = useRuntimeConfig()
  const { Hanko } = await import('@teamhanko/hanko-elements')
  hankoClient = new Hanko(config.public.HANKO_API_URL, hankoClientOptions)
  return hankoClient
}
